import {
  STANDARD_NUMBER_WIDTH,
  STANDARD_NUMBER_HEIGHT,
  LARGE_NUMBER_HEIGHT,
  LARGE_NUMBER_WIDTH,
} from '@Animation/constants'
import { RED_BALL_ATLAS_FRAMES, RED_BALL_TEXTURE_KEYS } from './constants'

export const RedBallTextureLoader = (scene: Phaser.Scene) => {
  if (!scene.textures.getTextureKeys().includes(RED_BALL_TEXTURE_KEYS.NUMBER_DEFAULT)) {
    scene.textures.addSpriteSheetFromAtlas(RED_BALL_TEXTURE_KEYS.NUMBER_DEFAULT, {
      atlas: RED_BALL_TEXTURE_KEYS.ATLAS,
      frame: RED_BALL_ATLAS_FRAMES.NUMBER_DEFAULT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED, {
      atlas: RED_BALL_TEXTURE_KEYS.ATLAS,
      frame: RED_BALL_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(RED_BALL_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(RED_BALL_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED, {
      atlas: RED_BALL_TEXTURE_KEYS.ATLAS,
      frame: RED_BALL_ATLAS_FRAMES.NUMBER_PLAYER_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }
  if (!scene.textures.getTextureKeys().includes(RED_BALL_TEXTURE_KEYS.NUMBER_HIT)) {
    scene.textures.addSpriteSheetFromAtlas(RED_BALL_TEXTURE_KEYS.NUMBER_HIT, {
      atlas: RED_BALL_TEXTURE_KEYS.ATLAS,
      frame: RED_BALL_ATLAS_FRAMES.NUMBER_HIT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }
  if (!scene.textures.getTextureKeys().includes(RED_BALL_TEXTURE_KEYS.NUMBER_HIT_TRANSITION)) {
    scene.textures.addSpriteSheetFromAtlas(RED_BALL_TEXTURE_KEYS.NUMBER_HIT_TRANSITION, {
      atlas: RED_BALL_TEXTURE_KEYS.ATLAS,
      frame: RED_BALL_ATLAS_FRAMES.NUMBER_HIT_TRANSITION,
      frameWidth: LARGE_NUMBER_WIDTH,
      frameHeight: LARGE_NUMBER_HEIGHT,
    })
  }
  if (
    !scene.textures
      .getTextureKeys()
      .includes(RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION_NUMBER)
  ) {
    scene.textures.addSpriteSheetFromAtlas(
      RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION_NUMBER,
      {
        atlas: RED_BALL_TEXTURE_KEYS.ATLAS,
        frame: RED_BALL_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED_TRANSITION_NUMBER,
        frameWidth: LARGE_NUMBER_WIDTH,
        frameHeight: LARGE_NUMBER_HEIGHT,
      },
    )
  }

  if (
    !scene.textures
      .getTextureKeys()
      .includes(RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION_BACKGROUND)
  ) {
    scene.textures.addSpriteSheetFromAtlas(
      RED_BALL_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION_BACKGROUND,
      {
        atlas: RED_BALL_TEXTURE_KEYS.ATLAS,
        frame: RED_BALL_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED_TRANSITION_BACKGROUND,
        frameWidth: 64,
        frameHeight: 64,
      },
    )
  }
}
